// @libraries
import * as Yup from 'yup'

const industry = Yup.string().required('Industry is required!')
const role = Yup.string().required('Role is required!')

export const validationSchema = Yup.object().shape({
  industry,
  role,
})
